import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { useEffect, useState } from "react";

import { useAuth } from "hooks";
import "modules/Auth/components/Login/Login.scss";
import { getBrowserLanguage } from "util/common";

export const Login = () => {
  const { loginWithGoogle } = useAuth();
  const { mutate: googleLogin } = loginWithGoogle;

  const [googleButtonWidth, setGoogleButtonWidth] = useState(0);

  const onSetButtonWidth = () => {
    const loginButton = document.getElementById("google-login-button");
    setGoogleButtonWidth(loginButton ? loginButton.clientWidth : 341);
  };

  useEffect(() => {
    onSetButtonWidth();
    window.addEventListener("resize", onSetButtonWidth);
    return () => {
      window.removeEventListener("resize", onSetButtonWidth);
    };
  }, []);

  const handleGoogleResponse = (token: CredentialResponse) => {
    if (!token?.credential) return;

    googleLogin({ id_token: token.credential });
  };

  return (
    <div className="LoginContainer">
      <div className="mt-15" id="google-login-button">
        <GoogleLogin width={googleButtonWidth} onSuccess={handleGoogleResponse} locale={getBrowserLanguage()} />
      </div>
    </div>
  );
};
